import React from 'react'
import { useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import PermanentPromotionBox from 'src/components/PermanentPromotionBox/PermanentPromotionBox'
import { ImageNames } from 'src/enums'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import Trns from 'src/localization/Trns'
import { registerAccountUrl } from 'src/navigation/urls'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

interface RegisterAccountPermanentPromotionBoxProps {
  className?: string
  dismissPromo: () => void
  isAccounts?: boolean
}

const RegisterAccountPermanentPromotionBox: React.FC<
  React.PropsWithChildren<RegisterAccountPermanentPromotionBoxProps>
> = (props): React.ReactElement => {
  const { analytics } = useAnalyticsContext()
  const accountsImage = useColorOrGrayscaleImage(ImageNames.Accounts)
  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )

  return (
    <PermanentPromotionBox
      className={props.className}
      imageSrc={accountsImage}
      title={<Trns source={'Add an account'} />}
      subtitle={
        props.isAccounts ? (
          <Trns
            source={
              'Register any number of company cards and manage spending across all of them in one place.'
            }
          />
        ) : (
          <Trns
            source={'Register a credit card account to create virtual cards.'}
          />
        )
      }
      navAway={{
        label: <Trns source={'Register an account'} />,
        to: registerAccountUrl(),
        ariaLabelSource: 'Register an account',
      }}
      onClick={(): void => {
        analytics?.track('add an account promo - add an account', {
          screen: calculatedBackgroundLocation.pathname,
        })
      }}
      dismissPromo={props.dismissPromo}
      usePlus
    />
  )
}

export default RegisterAccountPermanentPromotionBox
